"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentCardImage = void 0;
var Utilities_1 = require("../../Utilities");
var DocumentCardImage_base_1 = require("./DocumentCardImage.base");
var DocumentCardImage_styles_1 = require("./DocumentCardImage.styles");
exports.DocumentCardImage = (0, Utilities_1.styled)(DocumentCardImage_base_1.DocumentCardImageBase, DocumentCardImage_styles_1.getStyles, undefined, { scope: 'DocumentCardImage' });
//# sourceMappingURL=DocumentCardImage.js.map